
export enum TriStateBool {
    Unknown = 0,
    True = 1,
    False = 2
}
